import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";
import { app_url } from "app_config";
import moment from "moment";

const ActivityComp = ({ notifications }) => {
  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Task Activity</CardTitle>
          <ul className="verti-timeline list-unstyled">

            {
              notifications.map((item, i) => {
                return (
                  <li key={item.id} className={`event-list ${i === 0 && 'active'}`}>
                    <div className="event-timeline-dot">
                      <i className={`bx bxs-right-arrow-circle ${i === 0 && 'bx-fade-right'} font-size-18`} />
                    </div>
                    <div className="flex-shrink-0 d-flex">
                      <div className="me-3">
                        <h5 className="font-size-14">
                          {moment(item.createdAt).format("DD MMM")}{" "}
                          <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                        </h5>
                      </div>
                      <div className="flex-grow-1">
                        <div className="fw-bold fs-6"> {item.description || "Task Generated"}</div>
                        <div className="text-green">{item.title}</div>
                      </div>
                    </div>
                  </li>
                )
              })
            }


          </ul>
          {
            notifications.length === 0 &&
            <h6 className="text-primary mb-3">Your Task Notificatios will appear here..</h6>
          }

          {
            notifications.length === 0 &&
            <div>Not Found!</div>
          }

          {
            notifications.length ?
              <div className="text-end mt-4">
                <Link
                  to={`${app_url}notifications?module=task`}
                  className="btn btn-primary  btn-sm"
                >
                  View More <i className="mdi mdi-arrow-right ms-1" />
                </Link>
              </div> : null
          }
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default ActivityComp;